export enum LoginProviders {
    JWT = 'jwt',
    TDR = 'tdr',
}